<template>
  <div class="landing-wrapper">
     <!-- Navigation -->
    <nav class="navbar navbar-custom navbar-fixed-top" role="navigation">
        <a class="login-link" @click="$session.showLogin = true">Log In</a>
    </nav>

    <!-- Intro Header -->
    <header class="intro">
        <div class="intro-body">
            <div class="container">
                <div class="row">
                    <div class="col-8 offset-2">
                        <h1 class="brand-heading">Test Stand Portal</h1>
                        <p class="intro-text"><!--A free, responsive, one page Bootstrap theme.
                            <br>Created by Start Bootstrap.--></p>
                        <a href="#about" class="btn btn-circle page-scroll">
                            <i class="fa fa-angle-double-down animated"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!-- About Section -->
    <section id="about" class="container content-section text-center">
        <div class="row">
            <div class="col-8 offset-2">
                <h2>Powered by HIGHLIGHT Industries</h2>
                <p>Highlight was founded in 1981 with a mission to provide the highest value highest quality and highest technology products to our customers. Highlight is the world leader in equipment for testing stretch film. In addition Highlight provides the technology and equipment to evaluate the overall equipment and film effectiveness to increase production, reduce costs and ensure that products arrives undamaged. The HiLIFE System continues our commitment to provide the highest quality, highest value, highest technology solutions to the industry.</p>
            </div>
        </div>
    </section>

    <!-- Download Section -->
    <!--
    <section id="download" class="content-section text-center">
        <div class="download-section">
            <div class="container">
                <div class="col-8 offset-2">
                    <h2>Download Grayscale</h2>
                    <p>You can download Grayscale for free on the preview page at Start Bootstrap.</p>
                    <a href="http://startbootstrap.com/template-overviews/grayscale/" class="btn btn-default btn-lg">Visit Download Page</a>
                </div>
            </div>
        </div>
    </section>
    -->
    <!-- Contact Section -->
    <!--
    <section id="contact" class="container content-section text-center">
        <div class="row">
            <div class="col-8 offset-2">
                <h2>Contact Start Bootstrap</h2>
                <p>Feel free to email us to provide some feedback on our templates, give us suggestions for new templates and themes, or to just say hello!</p>
                <p><a href="mailto:feedback@startbootstrap.com">feedback@startbootstrap.com</a>
                </p>
                <ul class="list-inline banner-social-buttons">
                    <li>
                        <a href="https://twitter.com/SBootstrap" class="btn btn-default btn-lg"><i class="fa fa-twitter fa-fw"></i> <span class="network-name">Twitter</span></a>
                    </li>
                    <li>
                        <a href="https://github.com/IronSummitMedia/startbootstrap" class="btn btn-default btn-lg"><i class="fa fa-github fa-fw"></i> <span class="network-name">Github</span></a>
                    </li>
                    <li>
                        <a href="https://plus.google.com/+Startbootstrap/posts" class="btn btn-default btn-lg"><i class="fa fa-google-plus fa-fw"></i> <span class="network-name">Google+</span></a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
    -->
    <!-- Map Section -->

    <!-- Footer -->
    <footer style="background-color: rgba(100, 100, 100, 1); color: #fff;margin-top: 50px;">
        <div class="container text-center">
            <p>Copyright &copy; 2017 Highlight Industries</p>
        </div>
    </footer>
  </div>
</template>

<style lang="scss">
.landing-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 35px;
    text-transform: uppercase;
    font-family: "Montserrat", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 700;
    letter-spacing: 1px;
  }
  p {
    margin: 0 0 25px;
    font-size: 18px;
    line-height: 1.5;
  }
  @media (min-width: 768px) {
    p {
      margin: 0 0 35px;
      font-size: 20px;
      line-height: 1.6;
    }
  }
  a {
    color: #42DCA3;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
  a:hover,
  a:focus {
    text-decoration: none;
    color: #1d9b6c;
  }
  .light {
    font-weight: 400;
  }
  .navbar-custom {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    margin-bottom: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    text-transform: uppercase;
    font-family: "Montserrat", "Helvetica Neue", Helvetica, Arial, sans-serif;
    background-color: black;
    text-align: right;
    padding: 20px 30px;
    width: 100%;
    display: block;
  }
  .navbar-custom .navbar-toggle {
    color: white;
    background-color: rgba(255, 255, 255, 0.2);
    font-size: 12px;
  }
  .navbar-custom .navbar-toggle:focus,
  .navbar-custom .navbar-toggle:active {
    outline: none;
  }
  .navbar-custom .navbar-brand {
    font-weight: 700;
  }
  .navbar-custom .navbar-brand:focus {
    outline: none;
  }
  .navbar-custom a {
    color: white;
  }
  .navbar-custom .nav li a {
    -webkit-transition: background 0.3s ease-in-out;
    -moz-transition: background 0.3s ease-in-out;
    transition: background 0.3s ease-in-out;
  }
  .navbar-custom .nav li a:hover {
    color: rgba(255, 255, 255, 0.8);
    outline: none;
    background-color: transparent;
  }
  .navbar-custom .nav li a:focus,
  .navbar-custom .nav li a:active {
    outline: none;
    background-color: transparent;
  }
  .navbar-custom .nav li.active {
    outline: none;
  }
  .navbar-custom .nav li.active a {
    background-color: rgba(255, 255, 255, 0.3);
  }
  .navbar-custom .nav li.active a:hover {
    color: white;
  }
  @media (min-width: 768px) {
    .navbar-custom {
      padding: 20px 30px;
      border-bottom: none;
      letter-spacing: 1px;
      background: transparent;
      -webkit-transition: background 0.5s ease-in-out, padding 0.5s ease-in-out;
      -moz-transition: background 0.5s ease-in-out, padding 0.5s ease-in-out;
      transition: background 0.5s ease-in-out, padding 0.5s ease-in-out;
    }
    .navbar-custom.top-nav-collapse {
      padding: 0;
      background: black;
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    }
  }
  .intro {
    display: table;
    width: 100%;
    height: auto;
    padding: 100px 0;
    text-align: center;
    color: white;
    background: url('/static/img/hli-building-darkened.png') no-repeat bottom center scroll;
    background-color: black;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    -o-background-size: cover;
  }
  .intro .intro-body {
    display: table-cell;
    vertical-align: middle;
  }
  .intro .intro-body .brand-heading {
    font-size: 40px;
  }
  .intro .intro-body .intro-text {
    font-size: 18px;
  }
  @media (min-width: 768px) {
    .intro {
      height: 100%;
      padding: 0;
    }
    .intro .intro-body .brand-heading {
      font-size: 100px;
    }
    .intro .intro-body .intro-text {
      font-size: 26px;
    }
  }
  .btn-circle {
    width: 70px;
    height: 70px;
    margin-top: 15px;
    padding: 7px 16px;
    border: 2px solid white;
    border-radius: 100% !important;
    font-size: 40px;
    color: white;
    background: transparent;
    -webkit-transition: background 0.3s ease-in-out;
    -moz-transition: background 0.3s ease-in-out;
    transition: background 0.3s ease-in-out;
  }
  .btn-circle:hover,
  .btn-circle:focus {
    outline: none;
    color: white;
    background: rgba(255, 255, 255, 0.1);
  }
  .btn-circle i.animated {
    -webkit-transition-property: -webkit-transform;
    -webkit-transition-duration: 1s;
    -moz-transition-property: -moz-transform;
    -moz-transition-duration: 1s;
  }
  .btn-circle:hover i.animated {
    -webkit-animation-name: pulse;
    -moz-animation-name: pulse;
    -webkit-animation-duration: 1.5s;
    -moz-animation-duration: 1.5s;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
  }
  @-webkit-keyframes pulse {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    50% {
      -webkit-transform: scale(1.2);
      transform: scale(1.2);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  @-moz-keyframes pulse {
    0% {
      -moz-transform: scale(1);
      transform: scale(1);
    }
    50% {
      -moz-transform: scale(1.2);
      transform: scale(1.2);
    }
    100% {
      -moz-transform: scale(1);
      transform: scale(1);
    }
  }
  .content-section {
    padding-top: 100px;
  }
  .download-section {
    width: 100%;
    padding: 50px 0;
    color: white;
    // background: url(../img/downloads-bg.jpg) no-repeat center center scroll;
    background-color: black;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    -o-background-size: cover;
  }
  #map {
    width: 100%;
    height: 200px;
    margin-top: 100px;
  }
  @media (min-width: 767px) {
    .content-section {
      padding-top: 250px;
    }
    .download-section {
      padding: 100px 0;
    }
    #map {
      height: 400px;
      margin-top: 250px;
    }
  }
  .btn {
    text-transform: uppercase;
    font-family: "Montserrat", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 400;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    border-radius: 0;
  }
  .btn-default {
    border: 1px solid #42DCA3;
    color: #42DCA3;
    background-color: transparent;
  }
  .btn-default:hover,
  .btn-default:focus {
    border: 1px solid #42DCA3;
    outline: none;
    color: black;
    background-color: #42DCA3;
  }
  ul.banner-social-buttons {
    margin-top: 0;
  }
  @media (max-width: 1199px) {
    ul.banner-social-buttons {
      margin-top: 15px;
    }
  }
  @media (max-width: 767px) {
    ul.banner-social-buttons li {
      display: block;
      margin-bottom: 20px;
      padding: 0;
    }
    ul.banner-social-buttons li:last-child {
      margin-bottom: 0;
    }
  }
  footer {
    padding: 50px 0;
  }
  footer p {
    margin: 0;
  }
  ::-moz-selection {
    text-shadow: none;
    background: #fcfcfc;
    background: rgba(255, 255, 255, 0.2);
  }
  ::selection {
    text-shadow: none;
    background: #fcfcfc;
    background: rgba(255, 255, 255, 0.2);
  }
  img::selection {
    background: transparent;
  }
  img::-moz-selection {
    background: transparent;
  }
  body {
    webkit-tap-highlight-color: rgba(255, 255, 255, 0.2);
  }
  
}
</style>

<script>
export default {
  name: 'landing',
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// Landing.vue?6046c039